module.exports = __webpack_public_path__ + "static/media/street-art-chaser.f5df1a04.png";